import { useState, useEffect } from "react";
import { Layout } from "../components/Layout";
import { apiClient } from "../App";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Users, Tag, Calendar, TrendingUp } from "lucide-react";

export default function DashboardPage() {
  const [stats, setStats] = useState({
    customers: 0,
    tags: 0,
    events: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [customersRes, tagsRes] = await Promise.all([
          apiClient.get("/customers"),
          apiClient.get("/tags"),
        ]);
        
        const customers = customersRes.data;
        const totalEvents = customers.reduce((acc, c) => acc + (c.events?.length || 0), 0);
        
        setStats({
          customers: customers.length,
          tags: tagsRes.data.length,
          events: totalEvents,
        });
      } catch (error) {
        console.error("Error fetching stats:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  const statCards = [
    { title: "Kunden", value: stats.customers, icon: Users, color: "text-blue-600", bg: "bg-blue-100" },
    { title: "Tags", value: stats.tags, icon: Tag, color: "text-purple-600", bg: "bg-purple-100" },
    { title: "Ereignisse", value: stats.events, icon: Calendar, color: "text-green-600", bg: "bg-green-100" },
  ];

  return (
    <Layout title="Dashboard">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-testid="dashboard-stats">
        {statCards.map((stat) => (
          <Card key={stat.title} className="border-slate-200 shadow-sm hover:shadow-md transition-shadow duration-200">
            <CardHeader className="flex flex-row items-center justify-between pb-2">
              <CardTitle className="text-sm font-medium text-slate-500">{stat.title}</CardTitle>
              <div className={`p-2 rounded-lg ${stat.bg}`}>
                <stat.icon className={`w-5 h-5 ${stat.color}`} />
              </div>
            </CardHeader>
            <CardContent>
              <div className="text-3xl font-bold text-slate-900">
                {loading ? "..." : stat.value}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </Layout>
  );
}
